// extracted by mini-css-extract-plugin
module.exports = {"banner":"L3SK2","imageWrapper":"_2FtCw","detail":"O6oy3","title":"_3LVBQ","subtitle":"_1ZNKS","button":"w0UUt","image":"_1QUon"};